import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ps-design-system/components/Dialog";
import { Text } from "@ps-design-system/components/Text";

type DateRateFormLeaveDialogProps = {
  onBackToEdit: () => void;
  onLeave: () => void;
  open: boolean;
};

/** Confirms leaving the date rate form when it has unsaved changes. */
const DateRateFormLeaveDialog = ({
  onBackToEdit,
  onLeave,
  open,
}: DateRateFormLeaveDialogProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onBackToEdit();
    }
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={open}>
      <DialogContent size="sm" testId="date-rate-form-leave-dialog">
        <DialogHeader>
          <DialogTitle className="tw-m-0">
            <FormattedMessage
              id="hosting.date_rate_form.leave_dialog_heading"
              defaultMessage="Leave without saving?"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Text element="p" className="tw-m-0">
            <FormattedMessage
              id="hosting.date_rate_form.leave_dialog_body"
              defaultMessage="Anything you’ve entered won’t be saved."
            />
          </Text>
        </DialogBody>
        <DialogFooter className="sm:tw-px-32 sm:tw-py-24">
          <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
            <Button
              onClick={onBackToEdit}
              testId="date-rate-form-leave-dialog-back"
              variant="underline-m"
            >
              <FormattedMessage
                id="hosting.date_rate_form.leave_dialog_back_button"
                defaultMessage="Back to edit"
              />
            </Button>
            <Button
              onClick={onLeave}
              testId="date-rate-form-leave-dialog-leave"
            >
              <FormattedMessage
                id="hosting.date_rate_form.leave_dialog_leave_button"
                defaultMessage="Leave"
              />
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { DateRateFormLeaveDialog };
